import { get } from "lodash";
import { MdOpenInNew } from "react-icons/md";
import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";

const Card = ({
  id,
  icon,
  name,
  cost,
  currency,
  period,
  perYear,
  allIncluded,
  link,
  upsells,
}) => {
  return (
    <div className="quote-template__product-card">
      <div className="quote-template__product-card--body">
        <img src={icon} alt={name} />

        <div className="quote-template__product-card--infos">
          <h4 className="quote-template__product-card--name">{name}</h4>
          <h4>
            <span className="quote-template__product-card--price">
              {costToFrench(cost)} {CURRENCY_SYMBOL[currency]}
            </span>
            <small> {period}</small>
          </h4>
          <span>
            {`${(+cost * 12).toLocaleString("fr-FR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })} ${CURRENCY_SYMBOL[currency]} ${perYear} `}
            <small>{allIncluded}</small>
          </span>

          {get(upsells, id, []).map((upSell) => (
            <span key={get(upSell, "insurancePlan.id")}>
              {get(upSell, "insurancePlan.name")} - {get(upSell, "cost")}
              €/mois
            </span>
          ))}
        </div>
        <div className="quote-template__product-card--link">
          <MdOpenInNew size={14} />
          {link}
        </div>
      </div>
    </div>
  );
};

export default Card;
